module.exports = __webpack_public_path__ + "static/media/YS_skyline_Desktop_AE_B1_v2.40689d3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YS_skyline_Desktop_AE_B1_v2.jpg
// module id = 162
// module chunks = 0